export const environment = {
  production: false,
  apiUri: "https://canvasser-app-api-qa.plusmoreplatform.com",
  version: "0.0.6",
  recaptchaKey: "6Le_KBwqAAAAAFlQerWu3oLNbu2p1wJU6YYZoLk6",
};
